<template>
    <div style="height: 890px; width: 102.6%; position: relative" id="divMap">
        <!-- 左侧 -->
        <div style="
                position: absolute;
                top: 30px;
                left: 110px;
                z-index: 999;
                with: 30%;
            ">
            <comLeftDraw @drawLocation="drawLocation" @viewLocation="viewLocation" :key="reloadTimer"></comLeftDraw>
        </div>
        <!-- 右上角工具箱 -->
        <div style="
                position: absolute;
                top: 30px;
                right: 180px;
                z-index: 999;
                with: 30%;
            ">
            <comLeftTopToolbox @leftTopMapSwitch="leftTopMapSwitch" @sendBaseLayer="sendBaseLayer"
                @displayLgend="displayLgend" @zoomToCounty="zoomToCounty" @popInfo="popInfo"></comLeftTopToolbox>
        </div>
        <!-- 右侧 -->

        <!-- 图层控制 -->
        <el-dialog title="图层管理" :visible.sync="layerControlDialogVisible" width="15%" :modal-append-to-body="false">
            <div>
                <el-row>
                    <el-col>
                        <el-checkbox-group v-model="mapSwitcherSelects" @change="mapSwitcherChange"
                            style="text-align: left">
                            <el-checkbox v-for="item in mapSwitcherSum" :key="item" style="margin: 0.5rem" :label="item"
                                :value="item">
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
        <!-- 图例 -->
        <div style="position: absolute; bottom: 0px; left: 0px; z-index: 998">
            <comMapLgend v-if="displayLgendFlag && !isLoginSuccess()"></comMapLgend>
            <comMapLgend2 v-if="displayLgendFlag && isLoginSuccess()"></comMapLgend2>
        </div>
        <!-- 弹出框 -->
        <!-- 添加定位地图弹出框    -->
        <div id="newLocationPop">
            <comAddNewLocationPop :locationPopInfo="newLocationPopInfo" :lonlat="newLocationLonLat"
                @lonlatChange="lonlatChangeHandle" @cancleAddNewLocation="cancleAddNewLocation"
                @retryAddNewLocation="retryAddNewLocation" @saveAddNewLocation="saveAddNewLocation"></comAddNewLocationPop>
        </div>
        <!-- 点击数据点弹出框 -->
        <div id="clickDataPop">
            <comClickDataPop :clickDataPopInfo="clickDataPopInfo" @closeClickPop="closeClickPop"
                @correctLocation="correctLocation" @deleteLocation="deleteLocation"></comClickDataPop>
        </div>
    </div>
</template>

<script>
import {
    fullScreenStartLoading,
    fullScreenEndLoading,
} from '@/V3/js/loading.js'

import { initMap, changeBaseLayer, addWfsLayer } from '@/V3/js/map.js'
import { line_style, plane_style, point_style } from '@/V3/js/mapStyle.js'

import comLeftDraw from '@/V3/Main/Home/comLeftDraw'
import comRightDraw from '@/V3/Main/Home/comRightDraw'
import comToolBox from '@/V3/Main/Home/comToolBox'
import comMapLgend from '@/V3/Main/Home/comMapLgend'
import comMapLgend2 from '@/V3/Main/Home/comMapLgend2'
import comLeftTopToolbox from '@/V3/Main/Home/comLeftTopToolbox'

import comAddNewLocationPop from '@/V3/Main/Home/comAddNewLocationPop'

import comClickDataPop from '@/V3/Main/Home/comClickDataPop'
import 'ol/ol.css'
import { Map, View, Overlay } from 'ol'

import VectorSource from 'ol/source/Vector'
import GeoJSONFormat from 'ol/format/GeoJSON'

import VectorLayer from 'ol/layer/Vector'
import { transform, transformExtent, fromLonLat } from 'ol/proj'
import { OSM, TileWMS, Vector } from 'ol/source'

import Draw from 'ol/interaction/Draw'
import { unByKey } from 'ol/Observable.js'
import { WFS, GeoJSON } from 'ol/format'
import { MultiLineString, Point } from 'ol/geom'
import { Circle, Stroke, Style, Fill, Icon, Text } from 'ol/style'

import Feature from 'ol/Feature'
import {
    and as andFilter,
    equalTo as equalToFilter,
    like as likeFilter,
} from 'ol/format/filter'
import axios from 'axios'
import { Modify, Snap, Select } from 'ol/interaction'

import { toLonLat } from 'ol/proj'
import { toStringHDMS } from 'ol/coordinate'

import eventBus from '@/V3/js/eventBus'

export default {
    // directives: { elDragDialog },
    data() {
        return {
            // 重新加载子组件
            reloadTimer: '',
            // 工作单位
            userWork: '',
            tName: '',
            // OpenLayers Map对象
            map: {},
            centerLonLat: [101, 37.8],
            zoomLevel: 7,

            draw: {},
            drawLayer: {},

            //  先加载 已通过审核的聚落点
            displayJuLuoLayer: {},

            //newLocationPop 弹出对象
            newLocationPop: {},
            newLocationPopInfo: {
                censusenum: null,
                check_reas: null,
                check_stat: null,
                coor_x: null,
                coor_y: null,
                distance: null,
                excursus: null,
                fid_: null,
                household: null,
                id: null,
                input_reas: null,
                input_time: null,
                input_work: null,
                lev2: null,
                lev2_name: null,
                lev3: null,
                location: null,
                location_1: null,
                location_s: null,
                n_position: null,
                name: null,
                other: null,
                population: null,
                remark: null,
                tlocation: null,
                user: null,
            },
            newLocationLonLat: [],

            // clickDataPop 弹出对象
            clickDataPop: {},
            clickDataPopInfo: {
                censusenum: null,
                check_reas: null,
                check_stat: null,
                coor_x: null,
                coor_y: null,
                distance: null,
                excursus: null,
                fid_: null,
                household: null,
                id: null,
                input_reas: null,
                input_time: null,
                input_work: null,
                lev2: null,
                lev2_name: null,
                lev3: null,
                location: null,
                location_1: null,
                location_s: null,
                n_position: null,
                name: null,
                other: null,
                population: null,
                remark: null,
                tlocation: null,
                user: null,
            },

            highLightFeature: {},

            // 图层控制
            layerControlDialogVisible: false,
            //图层控制总共有哪些图层
            mapSwitcherSum: [
                '天地图底图',
                '1911年甘肃省级治所',
                '1911年甘肃府级治所',
                '1911年甘肃县级治所',
                '已定位聚落',
                '现代甘肃省级边界',
                '1911年甘肃省级边界',
                '1911年甘肃府级边界',
                '1911年甘肃县级边界',
            ],
            //图层控制选择了哪些图层
            mapSwitcherSelects: [
                '天地图底图',
                '1911年甘肃省级治所',
                '1911年甘肃府级治所',
                '1911年甘肃县级治所',
                '已定位聚落',
                '现代甘肃省级边界',
                '1911年甘肃省级边界',
                '1911年甘肃府级边界',
                '1911年甘肃县级边界',
            ],

            // 图例是否展示
            displayLgendFlag: false,

            // 缩放到县图层
            zoomToFeature: {},
            zoomToCountyLayer: {},
        }
    },
    components: {
        comLeftDraw,
        comAddNewLocationPop,
        comRightDraw,
        comToolBox,
        comMapLgend,
        comMapLgend2,
        comClickDataPop,
        comLeftTopToolbox,
    },
    mounted() {
        this.getUserWork()
        this.gettName()
        this.map = initMap('divMap', this.centerLonLat, this.zoomLevel)
        // 加载静态图层
        this.addStaticLayer1()
        // 初始化各种地图弹出框
        this.initMapPop()
        //  先加载 已通过审核的聚落点
        this.addPassOrUserCheckJuluoLayer("coor_x>0 and coor_y>0 and !(check_stat ==2)")
        // 从我的账号 我的数据跳转至地图界面
        eventBus.on('jumpViewJuLuo', (value) => {
            this.viewLocation(value)
        })

        this.clickMap()
        this.addAllDataJUluoLayer()
    },
    methods: {
        // 判断是否登录
        isLoginSuccess() {
            if (
                this.$cookie.get('isLogin') == 'success' ||
                this.$store.state.V3loginState == true
            ) {
                return true
            } else {
                return false
            }
        },
        // dateFormat
        dateFormat(format) {
            var date = new Date()
            var format_arr = {
                Y: date.getFullYear(),
                m:
                    date.getMonth() + 1 >= 10
                        ? date.getMonth() + 1
                        : '0' + (date.getMonth() + 1),
                d: date.getDate() >= 10 ? date.getDate() : '0' + date.getDate(),
                H:
                    date.getHours() >= 10
                        ? date.getHours()
                        : '0' + date.getHours(),
                i:
                    date.getMinutes() >= 10
                        ? date.getMinutes()
                        : '0' + date.getMinutes(),
                s:
                    date.getSeconds() >= 10
                        ? date.getSeconds()
                        : '0' + getSeconds(),
            }
            for (var key in format_arr) {
                format = format.replace(key, format_arr[key])
            }
            return format
        },
        //gettName()
        gettName() {
            axios({
                url: $webConfig.V3.backendAPI + 'getUsertName',
                method: 'post',
                data: JSON.stringify({
                    mail: this.getUser(),
                }),
            }).then((res) => {
                if (res.data.tName) {
                    this.tName = res.data.tName
                } else {
                    this.tName = ''
                }
            })
        },
        // getUser()
        getUser() {
            if (this.$cookie.get('mail') == null) {
                return this.$store.state.V3mail
            } else {
                return this.$cookie.get('mail')
            }
        },
        // getWork(){}
        getUserWork() {
            axios({
                url: $webConfig.V3.backendAPI + 'getUserWork',
                method: 'post',
                data: JSON.stringify({
                    mail: this.getUser(),
                }),
            }).then((res) => {
                if (res.data.work) {
                    this.userWork = res.data.work
                } else {
                    this.userWork = ''
                }
            })
        },
        // 已通过审核的聚落点
        addPassOrUserCheckJuluoLayer(CQL_FILTER) {
            this.map.removeLayer(this.displayJuLuoLayer)

            let url_params = {
                service: 'WFS',
                version: '1.0.0',
                request: 'GetFeature',
                typeName: 'lwdgis:v3data',
                outputFormat: 'application/json',
                sortBy: 'id',
                CQL_FILTER: CQL_FILTER,
            }
            let self = this
            let vtSource = new VectorSource({
                format: new GeoJSONFormat({
                    // geometryName: 'geom' // 因为数据源里面字段the_geom存储的是geometry，所以需要指定
                }),
                loader: function (extent, resolution, projection) {
                    const axioInstance = axios.create()
                    // 请求拦截器
                    axioInstance.interceptors.request.use(
                        (config) => {
                            fullScreenStartLoading()
                            return config
                        },
                        (error) => {
                            Promise.reject(error)
                        }
                    )
                    // 响应拦截器
                    axioInstance.interceptors.response.use(
                        (response) => {
                            fullScreenEndLoading()
                            return response
                        },
                        (error) => {
                            fullScreenEndLoading()
                            return Promise.reject(error)
                        }
                    )
                    axioInstance({
                        url: $webConfig.V3.owsBaseURL,
                        method: 'get',
                        params: url_params,
                    }).then((res) => {
                        var featureList = vtSource
                            .getFormat()
                            .readFeatures(res.data)
                        featureList.forEach((item, index) => {
                            item.setGeometry(
                                item
                                    .getGeometry()
                                    .transform('EPSG:4326', 'EPSG:3857')
                            )
                            vtSource.addFeature(item)
                        })
                    })
                },
            })

            let wfsVectorSource = vtSource
            let my_point_style = new point_style('')
            let user = self.getUser()

            let pointStyle = function (feature, resolution) {
                let text = ''
                if (resolution > 2319) {
                    text = ''
                } else {
                    text = feature.getProperties().name
                }

                // 用户自己定位的用红色 别人定位的用黑色
                if (user != feature.getProperties().user) {
                    my_point_style.defaultOther.getText().setText(text)
                    return my_point_style.defaultOther
                } else if (user == feature.getProperties().user) {
                    my_point_style.default.getText().setText(text)
                    return my_point_style.default
                }
            }

            this.displayJuLuoLayer = new VectorLayer({
                source: wfsVectorSource,
                style: pointStyle,
                title: '已定位聚落',
                zIndex: 999,
            })

            this.map.addLayer(this.displayJuLuoLayer)
        },
        // 加载全部聚落数据点图层
        addAllDataJUluoLayer() {
            let url_params = {
                service: 'WFS',
                version: '1.0.0',
                request: 'GetFeature',
                typeName: 'lwdgis:v3data',
                outputFormat: 'application/json',
            }
            let vtSource = new VectorSource({
                format: new GeoJSONFormat({
                    // geometryName: 'geom', // 因为数据源里面字段the_geom存储的是geometry，所以需要指定
                }),
                loader: function (extent, resolution, projection) {
                    axios({
                        url: $webConfig.V3.owsBaseURL,
                        method: 'get',
                        params: url_params,
                    }).then((res) => {
                        var featureList = vtSource
                            .getFormat()
                            .readFeatures(res.data)
                        featureList.forEach((item, index) => {
                            item.setGeometry(
                                item
                                    .getGeometry()
                                    .transform('EPSG:4326', 'EPSG:3857')
                            )
                            vtSource.addFeature(item)
                        })
                    })
                },
            })

            let wfsVectorSource = vtSource

            let allDataLayer = new VectorLayer({
                source: wfsVectorSource,
                title: '全部数据点',
                style: new Style({
                    fill: new Fill({
                        color: 'rgba(255, 255, 255, 0.2)',
                    }),
                    image: new Circle({
                        radius: 7,
                        fill: new Fill({
                            color: 'rgba(255, 255, 255, 0.2)',
                        }),
                    }),
                }),
                zIndex: -1,
            })
            this.map.addLayer(allDataLayer)
        },
        // map 对象点击事件
        clickMap() {
            let self = this
            this.map.on('singleclick', function (evt) {
                // 恢复上次点击要素的符号
                if (self.highLightFeature != undefined) {
                    if (self.highLightFeature.setStyle != undefined) {
                        self.highLightFeature.setStyle('')
                    }
                }
                const coordinate = evt.coordinate
                const hdms = toStringHDMS(toLonLat(coordinate))

                let pixel = self.map.getEventPixel(evt.originalEvent)

                let res = self.map.forEachFeatureAtPixel(
                    pixel,
                    function (feature, layer) {
                        let res = {
                            feature: feature,
                            layer: layer,
                        }
                        return res
                    }
                )
                if (
                    res.feature != undefined &&
                    res.layer.getProperties().title == '已定位聚落'
                ) {
                    //为选中的Point 添加样式
                    self.highLightFeature = res.feature
                    let my_point_style = new point_style(
                        res.feature.getProperties().name
                    )
                    self.highLightFeature.setStyle(my_point_style.highlight)

                    self.clickDataPopInfo = res.feature.getProperties()
                    let centerLonLat = [
                        res.feature.getGeometry().getExtent()[0],
                        res.feature.getGeometry().getExtent()[1],
                    ]
                    self.clickDataPop.setPosition(centerLonLat)
                }
                // if (self.selFeature != undefined) {
                //     self.selFeatureData = self.selFeature.getProperties()

                //     // let lonlat = toLonLat(
                //     //     self.selFeature.getGeometry().getCoordinates()
                //     // )
                // } else {
                //     self.overLay.setPosition(undefined)
                // }
            })
        },
        // 关闭 已定位聚落 数据点 弹出框
        closeClickPop() {
            this.clickDataPop.setPosition(undefined)
            // 恢复上次点击要素的符号
            if (this.highLightFeature != undefined) {
                if (this.highLightFeature.setStyle != undefined) {
                    this.highLightFeature.setStyle('')
                }
            }
        },
        addStaticLayer1() {
            let my_line_style = new line_style('')
            let my_plane_style = new plane_style()
            let my_point_style = new point_style('')

            // 缩放到县图层
            let zoomToCountyLayerUrl =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gcounty&outputFormat=application/json'

            let zoomToCountyStyle = my_plane_style.prefecture_seat_tranparent
            this.zoomToCountyLayer = addWfsLayer(
                zoomToCountyLayerUrl,
                zoomToCountyStyle,
                '缩放到县图层',
                8
            )
            this.map.addLayer(this.zoomToCountyLayer)
            // //加载现代甘肃省市级政区边界
            let county_now_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gmodernline&outputFormat=application/json'

            let county_now_wfs_style = my_line_style.gmodern
            let county_now_layer = addWfsLayer(
                county_now_wfs_url,
                county_now_wfs_style,
                '现代甘肃省级边界',
                5
            )
            this.map.addLayer(county_now_layer)
            // 加载1911年甘肃县政区边界
            let county_old_wfs_url2 =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gline3&outputFormat=application/json'

            let county_old_wfs_style2 = my_line_style.county_old2
            let county_old_layer2 = addWfsLayer(
                county_old_wfs_url2,
                county_old_wfs_style2,
                '1911年甘肃县级边界',
                5
            )
            this.map.addLayer(county_old_layer2)
            //加载1911年甘肃市政区边界
            let county_old_wfs_url1 =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gline2&outputFormat=application/json'

            let county_old_wfs_style1 = my_line_style.county_old1
            let county_old_layer1 = addWfsLayer(
                county_old_wfs_url1,
                county_old_wfs_style1,
                '1911年甘肃府级边界',
                5
            )
            this.map.addLayer(county_old_layer1)
            //加载1911年甘肃省政区边界
            let county_old_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gline1&outputFormat=application/json'

            let county_old_wfs_style = my_line_style.county_old
            let county_old_layer = addWfsLayer(
                county_old_wfs_url,
                county_old_wfs_style,
                '1911年甘肃省级边界',
                5
            )
            this.map.addLayer(county_old_layer)


            // 加载1911年县级政区治所
            let county_seat_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gpoint3&outputFormat=application/json'

            let county_seat_wfs_style = my_point_style.county_seat_label
            this.county_seat_layer = addWfsLayer(
                county_seat_wfs_url,
                county_seat_wfs_style,
                '1911年甘肃县级治所',
                5
            )
            this.map.addLayer(this.county_seat_layer)
            // 加载1911年府级政区治所
            let county_seat_wfs_url1 =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gpoint2&outputFormat=application/json'


            let county_seat_wfs_style1 = my_point_style.county_seat_label1
            this.county_seat_layer1 = addWfsLayer(
                county_seat_wfs_url1,
                county_seat_wfs_style1,
                '1911年甘肃府级治所',
                5
            )
            this.map.addLayer(this.county_seat_layer1)
            //加载1911年省级政区治所
            let province_seat_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gpoint1&outputFormat=application/json'
            let province_seat_wfs_style = my_point_style.province_seat
            this.prefecture_seat_layer = addWfsLayer(
                province_seat_wfs_url,
                province_seat_wfs_style,
                '1911年甘肃省级治所',
                5
            )
            this.map.addLayer(this.prefecture_seat_layer)


        },

        // 初始化各种地图弹出框
        initMapPop() {
            // 初始 newLocationPop 弹出框
            var container = document.getElementById('newLocationPop')
            this.newLocationPop = new Overlay({
                element: container,
                autoPan: true,
                offset: [0, -10],
                positioning: 'bottom-center',
                stopEvent: true,
                autoPanAnimation: { duration: 250 },
            })

            this.map.addOverlay(this.newLocationPop)
            this.newLocationPop.setPosition(undefined)

            // 初始 clickDadaPop 弹出框clickDataPop
            var container = document.getElementById('clickDataPop')
            this.clickDataPop = new Overlay({
                element: container,
                autoPan: true,
                offset: [0, -10],
                positioning: 'bottom-center',
                stopEvent: true,
                autoPanAnimation: { duration: 250 },
            })

            this.map.addOverlay(this.clickDataPop)
            this.clickDataPop.setPosition(undefined)
        },
        // 添加定位弹框对象恢复初始值
        initNewLocationPop() {
            this.newLocationPop.setPosition(undefined)
            this.newLocationPopInfo = {
                censusenum: null,
                check_reas: null,
                check_stat: null,
                coor_x: null,
                coor_y: null,
                distance: null,
                excursus: null,
                fid_: null,
                household: null,
                id: null,
                input_reas: null,
                input_time: null,
                input_work: null,
                lev2: null,
                lev2_name: null,
                lev3: null,
                location: null,
                location_1: null,
                location_s: null,
                n_position: null,
                name: null,
                other: null,
                population: null,
                remark: null,
                tlocation: null,
                user: null,
            }
            // this.newLocationLonLat = []
        },
        clearBeforeNewLocation(){
            this.initNewLocationPop()

            this.map.removeLayer(this.drawLayer)
            this.map.removeInteraction(this.draw)
        },
        // 取消添加定位
        cancleAddNewLocation() {
            this.initNewLocationPop()

            this.map.removeLayer(this.drawLayer)
            this.map.removeInteraction(this.draw)
            // 刷新页面
            location.reload();

        },
        // 换个位置添加定位
        retryAddNewLocation() {
            this.newLocationPop.setPosition(undefined)
            // this.map.removeLayer(this.drawLayer)
        },
        // 添加定位 用户重新输入经纬度了 draw的点要重新变化
        lonlatChangeHandle(value) {
            this.drawLayer
                .getSource()
                .getFeatures()
                .forEach((feature) => {
                    let lon = Number(value[0])
                    let lat = Number(value[1])
                    let coord = transform([lon, lat], 'EPSG:4326', 'EPSG:3857')
                    feature
                        .getGeometry()
                        .setCoordinates([
                            parseFloat(coord[0]),
                            parseFloat(coord[1]),
                        ])
                    this.newLocationPop.setPosition([
                        parseFloat(coord[0]),
                        parseFloat(coord[1]),
                    ])

                    this.map
                        .getView()
                        .setCenter(feature.getGeometry().flatCoordinates)
                })
        },
        // 添加定位
        drawLocation(value) {
            // 执行一遍取消定位的逻辑(除了 window.relod)
            this.clearBeforeNewLocation()

            const source = new VectorSource()
            let my_point_style = new point_style('')
            this.drawLayer = new VectorLayer({
                source: source,
                style: my_point_style.highlight,
                zIndex: 9999,
            })
            this.map.addLayer(this.drawLayer)

            this.draw = new Draw({
                source: source,
                type: 'Point',
                style: new Style({
                    image: new Icon({
                        src: '../../static/img/cursor.png',
                    }),
                }),
            })
            this.map.addInteraction(this.draw)
            let self = this
            this.draw.on('drawend', function (e) {
                let centerLonLat = [
                    e.feature.getGeometry().getExtent()[0],
                    e.feature.getGeometry().getExtent()[1],
                ]
                self.newLocationPop.setPosition(centerLonLat)
                self.newLocationPopInfo = value
                let transformLonLat = transform(
                    centerLonLat,
                    'EPSG:3857',
                    'EPSG:4326'
                )
                self.newLocationLonLat = transformLonLat
                // 经纬度保留六位小数
                // console.log(self.newLocationLonLat)
                self.newLocationLonLat = [
                    parseFloat(self.newLocationLonLat[0].toFixed(6)),
                    parseFloat(self.newLocationLonLat[1].toFixed(6)),
                ]

            })
        },

        // 保存定位
        saveAddNewLocation(value) {
            this.cancleAddNewLocation()
            let self = this
            this.map.getLayers().forEach((layer) => {
                if (layer.getProperties().title == '全部数据点') {
                    let features = []
                    let content = ''

                    layer
                        .getSource()
                        .getFeatures()
                        .forEach((feature) => {
                            if (feature.getProperties().id == value.data.id) {
                                // 判断是添加定位还是修正定位

                                if (
                                    feature.getProperties().check_stat ==
                                    null ||
                                    feature.getProperties().check_stat == 2
                                ) {
                                    content = '添加定位'
                                } else if (
                                    feature.getProperties().check_stat == 0 ||
                                    feature.getProperties().check_stat == 1
                                ) {
                                    content = '纠正定位'
                                }

                                feature
                                    .getGeometry()
                                    .setCoordinates([
                                        value.lonlat[1],
                                        value.lonlat[0],
                                    ])
                                feature.set('coor_x', value.lonlat[1])

                                feature.set('coor_y', value.lonlat[0])
                                feature.set('user', self.getUser())
                                feature.set('other', self.tName)
                                feature.set(
                                    'input_time',
                                    self.dateFormat('Y-m-d H:i:s')
                                )
                                feature.set('input_reas', value.reason_position)
                                feature.set('n_position', value.n_position)

                                feature.set('input_work', self.userWork)
                                feature.set('check_stat', 0)
                                feature.set('location_1', 0)
                                features.push(feature)
                            }
                        })
                    self.newLocationsendXML(features, content)
                }
            })
        },
        // 记录操作记录
        recordOperation(content, result, property) {
            // // 记录用户行为 修改数据
            let operationJSON = {
                mail: this.getUser(),
                tName: this.tName,
                dataID: property.id,
                juluo: property.name,
                country: property.lev2_name,
                date: property.input_time,
                content: content,
                result: result,
                other: '',
            }
            let pointsAdd = {
                mail: this.getUser(),
                points: '10',
            }
            axios.post($webConfig.V3.backendAPI + 'addOperation', operationJSON)
        },
        // 保存定位发送请求体
        newLocationsendXML(features, content) {
            let self = this
            let WFSTSerializer = new WFS()
            let featObject = WFSTSerializer.writeTransaction(
                null,
                features,
                null,
                {
                    featureType: 'v3data', //feature对应图层
                    featureNS: $webConfig.V3.GeoseverIP + '/lwdgis', //为创建工作区时的命名空间URI
                    geometryName: 'geom',
                }
            )
            // 转换为xml内容发送到服务器端
            let serializer = new XMLSerializer()
            let featString = serializer.serializeToString(featObject)

            const axioInstance = axios.create()
            // 请求拦截器
            axioInstance.interceptors.request.use(
                (config) => {
                    fullScreenStartLoading()
                    return config
                },
                (error) => {
                    Promise.reject(error)
                }
            )
            // 响应拦截器
            axioInstance.interceptors.response.use(
                (response) => {
                    fullScreenEndLoading()
                    return response
                },
                (error) => {
                    fullScreenEndLoading()
                    return Promise.reject(error)
                }
            )
            // 发送请求
            axioInstance
                .post(
                    $webConfig.V3.GeoseverIP + '/wfs?service=wfs',
                    this.replaceText(featString, 'geom', 'v3data'),
                    {
                        headers: {
                            'Content-Type': 'text/xml',
                        },
                    }
                )
                .then((e) => {
                    if (content != "") {
                        self.recordOperation(
                            content,
                            '待管理员审核',
                            features[0].getProperties()
                        )
                    }

                    if (e.status == 200) {
                        // console.log(e)
                        if (content != "") {
                            self.$message({
                                message: '已提交至管理员审核',
                                type: 'success',
                            })
                        } else {
                            self.$message({
                                message: '已删除定位',
                                type: 'success',
                            })
                        }

                        self.reloadTimer = new Date().getTime()
                        // 更新 地图上的数据点
                        self.addPassOrUserCheckJuluoLayer("coor_x>0 and coor_y>0 and !(check_stat ==2)")

                    }
                })
        },
        // 不知道为什么 更改点位置 的xml 请求体有问题 替换其中的关键字即可
        // 找了好久
        replaceText(text, key1, key2) {
            let temp1 = 'feature:' + key2
            let temp2 = 'lwdgis:' + key2
            return text.replace('geometry', key1).replace(temp1, temp2)
        },

        // 查看定位
        viewLocation(value) {
            let self = this
            // 恢复上次点击要素的符号
            if (self.highLightFeature != undefined) {
                if (self.highLightFeature.setStyle != undefined) {
                    self.highLightFeature.setStyle('')
                }
            }
            this.displayJuLuoLayer
                .getSource()
                .getFeatures()
                .forEach((feature) => {
                    if (feature.getProperties().id == value.id) {
                        //为选中的Point 添加样式
                        self.highLightFeature = feature
                        let my_point_style = new point_style(
                            feature.getProperties().name
                        )
                        self.highLightFeature.setStyle(my_point_style.highlight)

                        self.clickDataPopInfo = feature.getProperties()
                        let centerLonLat = [
                            feature.getGeometry().getExtent()[0],
                            feature.getGeometry().getExtent()[1],
                        ]
                        self.clickDataPop.setPosition(centerLonLat)

                        // 视角移到弹框
                        self.map
                            .getView()
                            .setCenter([
                                centerLonLat[0],
                                centerLonLat[1] + 180000,
                            ])

                        self.map.getView().setZoom(7.5)
                    }
                })
        },
        // 纠正定位
        correctLocation(value) {
            this.closeClickPop()
            this.drawLocation(value)
        },
        // 删除定位
        deleteLocation(value) {
            this.closeClickPop()
            let self = this
            this.map.getLayers().forEach((layer) => {
                if (layer.getProperties().title == '全部数据点') {
                    let features = []
                    let content = ''

                    layer
                        .getSource()
                        .getFeatures()
                        .forEach((feature) => {
                            if (feature.getProperties().id == value.id) {

                                let centerLonLat = [
                                    feature.getGeometry().getExtent()[0],
                                    feature.getGeometry().getExtent()[1],
                                ]

                                let transformLonLat = transform(
                                    centerLonLat,
                                    'EPSG:3857',
                                    'EPSG:4326'
                                )
                                let newLonlat = [
                                    transformLonLat[1],
                                    transformLonLat[0],
                                ]
                                feature.getGeometry().setCoordinates(newLonlat)

                                feature.set('coor_x', 0)

                                feature.set('coor_y', 0)
                                feature.set('user', self.getUser())
                                feature.set('other', self.tName)
                                feature.set(
                                    'input_time',
                                    self.dateFormat('Y-m-d H:i:s')
                                )
                                feature.set('input_reas', "管理员删除定位")
                                feature.set('n_position', value.n_position)

                                feature.set('input_work', self.userWork)
                                feature.set('check_stat', 2)
                                feature.set('location_1', 0)
                                features.push(feature)
                            }
                        })
                    self.newLocationsendXML(features, content)
                }
            })
        },

        // 底图切换
        sendBaseLayer(value) {
            if (value == 'image') {
                changeBaseLayer(this.map, value)
            }
            changeBaseLayer(this.map, value)
        },
        // 图层控制
        layerControlDialog() {
            this.layerControlDialogVisible = true
        },
        leftTopMapSwitch(data) {
            this.mapSwitcherChange(data)
        },
        mapSwitcherChange(data, check) {
            let temp = {
                天地图底图: false,
                '1911年甘肃省级治所': false,
                '1911年甘肃府级治所': false,
                '1911年甘肃县级治所': false,
                已定位聚落: false,
                现代甘肃省级边界: false,
                '1911年甘肃省级边界': false,
                '1911年甘肃府级边界': false,
                '1911年甘肃县级边界': false,
            }
            data.forEach((item) => {
                temp[item] = true
            })
            this.map.getLayers().forEach((layer) => {
                if (layer != undefined) {
                    console.log(layer.getProperties().title)
                    if (layer.getProperties().title == '天地图底图') {
                        layer.setVisible(temp['天地图底图'])
                    }
                    if (layer.getProperties().title == '天地图底图注记') {
                        layer.setVisible(temp['天地图底图'])
                    }
                    if (layer.getProperties().title == '1911年甘肃省级治所') {
                        layer.setVisible(temp['1911年甘肃省级治所'])
                    }
                    if (layer.getProperties().title == '1911年甘肃县级治所') {
                        layer.setVisible(temp['1911年甘肃县级治所'])
                    }
                    if (layer.getProperties().title == '1911年甘肃府级治所') {
                        layer.setVisible(temp['1911年甘肃府级治所'])
                    }
                    if (layer.getProperties().title == '已定位聚落') {
                        layer.setVisible(temp['已定位聚落'])
                    }
                    if (
                        layer.getProperties().title == '现代甘肃省级边界'
                    ) {
                        layer.setVisible(temp['现代甘肃省级边界'])
                    }
                    if (layer.getProperties().title == '1911年甘肃省级边界') {

                        layer.setVisible(temp['1911年甘肃省级边界'])
                    }
                    if (layer.getProperties().title == '1911年甘肃府级边界') {
                        layer.setVisible(temp['1911年甘肃府级边界'])
                    }
                    if (layer.getProperties().title == '1911年甘肃县级边界') {
                        layer.setVisible(temp['1911年甘肃县级边界'])
                    }
                }
            })
        },

        // 图例展示
        displayLgend() {
            this.displayLgendFlag = !this.displayLgendFlag
        },

        // 缩放到县
        zoomToCounty(value) {
            // 恢复要素的符号样式
            if (this.zoomToFeature != undefined) {
                if (this.zoomToFeature.setStyle != undefined) {
                    this.zoomToFeature.setStyle('')
                }
            }
            let flag = false
            this.zoomToCountyLayer
                .getSource()
                .getFeatures()
                .forEach((feature) => {
                    if (feature.getProperties().CHNAME == value) {
                        this.zoomToFeature = feature
                        let my_plane_style = new plane_style(value)
                        this.zoomToFeature.setStyle(my_plane_style.selPolygon)
                        this.zoomToCountyLayer.changed()
                        this.map
                            .getView()
                            .setCenter(
                                this.zoomToFeature.getGeometry().flatCoordinates
                            )
                        this.map.getView().setZoom(9)
                        flag = true
                    }
                })
            if (!flag) {
                this.$message({
                    message: '暂时无法定位',
                    type: 'info',
                })

            }
        },

        // 右侧搜索 到结果弹出信息框
        popInfo(value) {
            this.viewLocation(value)
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/V3/Main/comHome.vue